// extracted by mini-css-extract-plugin
export default {"container":"kPSFEwds1zFk-0oZU9R1jQ==","details":"zx-9ocsiHnfDiah3dwY6sQ=="};